import React, { useEffect, useState } from "react";
import { FileUploader } from "../leads/FileUploader";
import { LeadUploadsList } from "../leads/LeadUploadsList";
import { CsvUploader } from "../leads/CsvUploader";
import { useOrganization } from "../../App";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";

export default function LeadUploadsPage() {
  const { currentOrganization } = useOrganization();
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    // Initialize any data loading here
    setLoading(false);
  }, [currentOrganization]);

  const handleUploadComplete = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-none p-6 text-foreground">
        <h3 className="text-lg font-medium mb-4">Upload Leads</h3>
        <Tabs defaultValue="csv" className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-4">
            <TabsTrigger value="csv">CSV Upload</TabsTrigger>
            <TabsTrigger value="resume">Resume Upload</TabsTrigger>
          </TabsList>
          <TabsContent value="csv">
            <CsvUploader
              organizationId={currentOrganization?.id}
              onUploadComplete={handleUploadComplete}
            />
          </TabsContent>
          <TabsContent value="resume">
            <FileUploader
              organizationId={currentOrganization?.id}
              onUploadComplete={handleUploadComplete}
            />
          </TabsContent>
        </Tabs>
      </div>

      <div className="bg-card border border-border rounded-none p-6 text-foreground">
        <h3 className="text-lg font-medium mb-4">Recent Uploads</h3>
        {loading ? (
          <p className="text-muted-foreground">Loading uploads...</p>
        ) : (
          <LeadUploadsList
            key={refreshKey}
            organizationId={currentOrganization?.id}
          />
        )}
      </div>
    </div>
  );
}
